module.exports = __webpack_public_path__ + "img/10.ce53dbf3.png";